{
  "version": 1,
  "asset_id": "d17dfb9c-d685-4987-bf6c-8b9c2c6bf0d9",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/d17dfb9c-d685-4987-bf6c-8b9c2c6bf0d9/team-1280.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/d17dfb9c-d685-4987-bf6c-8b9c2c6bf0d9/team-1280.avif",
  "original_filename": "team-1280.avif",
  "size": 30627,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:27:01Z"
}
